export var commonId;
(function (commonId) {
    commonId["recommendations"] = "recommendations";
})(commonId || (commonId = {}));
export const marketsRoute = {
    markets: "/markets",
};
export const viewInDetail = {
    viewall: "/viewall",
};
export const MarketTabsConstants = {
    Equity: "equity",
    MutualFunds: "mutualFunds",
    PrimaryMarket: "primaryMarket",
    NCDs: "ncds",
    Futures: "futures",
    Options: "options",
    Currency: "currency",
    Commodity: "commodity",
    ETFs: "etfs",
    OptionTool: "option-tool",
};
